import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';

export const AccountPaginationWrapper = styled.div`
    ${media.mobileDevice`
    position: fixed;
    width: 100%;
    bottom: 0;
    margin: 0 auto;
    `}
`;

export const DesktopView = styled.div`
    display: block;
    @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) {
        width: 100% !important;
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        width: 100%;
    }
    ${media.mobileDevice`
        display: none;
    `}
`;

export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 100%;
    ${media.mobileDevice`
        flex-direction:column;
        padding-top: 10px;
        justify-content: space-between;
        padding-bottom:${({ padding }) =>
            ENVIRONMENTVARIABLE
                ? `max(${
                      padding ? padding : '1.125rem'
                  }, calc(4*env(safe-area-inset-bottom)))`
                : padding
                ? padding
                : '1.125rem'} 
    `}
`;
export const MobileView = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
        background-color: #ffff;
    `}
`;

export const HeaderContainer = styled(Grid)`
    padding: 15px 20px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    margin-top: 2px;
    margin-bottom: 10px;
    ${media.mobileDevice`
     display:none !important;
        `}
`;

export const PaginationContainer = styled.div`
    height: 48px;
    box-shadow: none;
    border-radius: 4px 4px 0px 0px;
    opacity: 1;

    .p-paginator {
       // padding: 0;
    }

    ${media.smalDevice`                    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
    ${media.mediumDevice`    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
    ${media.mobileDevice`
    flex-direction:column;
    margin: 10px 0px 0px 0px;
    box-shadow: none;
    border-radius: none;        
`}
`;

export const SearchBoxContainer = styled.div`
    .p-input-icon-right > i:last-of-type,
    .p-input-icon-right > svg:last-of-type,
    .p-input-icon-right > .p-input-suffix {
        left: 19rem;
    }
    ${media.mobileDevice`
    margin-top: 0px;
    margin-left: 0px;
    margin-bottom: 10px;
    .p-input-icon-right > i:last-of-type,
    .p-input-icon-right > svg:last-of-type,
    .p-input-icon-right > .p-input-suffix {
        right: 6% !important;
        left: 20rem;
    }
    `};
`;
export const BodyGridContainer = styled(Grid)`
    padding: 15px 20px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    margin-top: 3px;
    margin-bottom: 10px;
    font-size: 24px;
    ${media.mobileDevice` 
    margin: 0px 0px 11px 0px;
    `}
`;

export const SpecialityGrid = styled(Grid)`
    text-align: left;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.11px;
    color: #000000;
    ${media.mobileDevice`    
padding-left: 1px;
`}
`;

export const EmailPhoneGrid = styled(Grid)`
    ${media.mobileDevice`    
        padding-left: 1px;
        display: block;
    `};
`;

export const EmailContainer = styled(Grid)`
    text-align: left;
    font-size: 12px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #140f4b;
    ${media.mobileDevice`
margin-left: 0px;
`}
`;

export const PhoneContainer = styled(Grid)`
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    font-size: 12px;
    letter-spacing: 0.05px;
    color: #140f4b;
    text-transform: ${(props) => props.textTransform};
    ${media.mobileDevice`
    margin-left: 0px;
`}
`;

export const HeaderTextContainer = styled(Grid)`
    color: #3c3c3c;
    opacity: 0.7;
    font-size: 13px;
    font-family: AvenirNextWorld Demi;
    text-align: left;
`;

export const HeaderTextContainer1 = styled(Grid)`
    color: #3c3c3c;
    opacity: 0.7;
    font-size: 13px;
    font-family: AvenirNextWorld Demi;
    text-align: left;
`;
export const BodyTextContainer = styled(Grid)`
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    font-size: 14px;
    letter-spacing: -0.11px;
    color: #1010eb;
    ${media.mobileDevice` 
    display: flex;
    justify-content: space-between;
    `}
`;

export const CityGrid = styled(Grid)`
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #140f4b;
    opacity: 0.6;
    font-size: 12px;
    text-transform: uppercase;
    ${media.mobileDevice` 
    text-align: start;
`};
`;

export const ProductGuideListContainerHeader = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    border-radius: 6px;
    ${media.mediumDevice`
    `}
    ${media.smalDevice`
    `}

    ${media.mobileDevice`
        display: block;
        margin: -4px 0 0 0;
        border-top-left-radius: ${(props) =>
            props.filterDataOpen | props.accountSearchOpen ? 0 : '20px'};
        border-top-right-radius: ${(props) =>
            props.filterDataOpen | props.accountSearchOpen ? 0 : '20px'};
        padding: 20px 16px 15px 16px;
        height: auto;
        border-bottom-left-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        border-bottom-right-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
    `}
`;

export const ProductGuideListContainer = styled.div`
    height: calc(100vh - 29rem);
    overflow-y: scroll;
    padding-bottom: 40px;

    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        margin-top: 10px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
        height: 30px;
    }

    ${media.mediumDevice`
        &::-webkit-scrollbar {
            display: ${({ theme }) => theme.scrollOption.show};
            width: 5px;
        }
        &::-webkit-scrollbar-track {
            margin-top: 10px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({ theme }) => theme.scrollOption.thumb_color};
            border-radius: ${({ theme }) => theme.scrollOption.border_radius};
            height: 30px;
        }
    `}
    ${media.smalDevice`
        height: calc(100vh - 28rem);
        flex-direction: column;

        &::-webkit-scrollbar {
            display: ${({ theme }) => theme.scrollOption.show};
            width: 5px;
        }
        &::-webkit-scrollbar-track {
            margin-top: 10px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({ theme }) => theme.scrollOption.thumb_color};
            border-radius: ${({ theme }) => theme.scrollOption.border_radius};
            height: 30px;
        }
    `}

    ${media.mobileDevice`
        display: block;
        margin: -14px 0 0 0;
        padding: 2px 16px 130px 16px;
        height: calc(100vh - 27rem);
        border-bottom-left-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        border-bottom-right-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        &::-webkit-scrollbar {
            display: ${({ theme }) => theme.scrollOption.show};
            width: 5px;
        }
        &::-webkit-scrollbar-track {
            margin-top: 0px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({ theme }) => theme.scrollOption.thumb_color};
            border-radius: ${({ theme }) => theme.scrollOption.border_radius};
            height: 7rem;
        }
    `}
`;
